import { render, staticRenderFns } from "./DashboardChartFilters.vue?vue&type=template&id=1dac1c5e&scoped=true&lang=pug&"
import script from "./DashboardChartFilters.vue?vue&type=script&lang=js&"
export * from "./DashboardChartFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac1c5e",
  null
  
)

export default component.exports